/**
 * @module order-payment/credit-card-address
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { InputItemData } from '@support/shared/widgets/interfaces/address-form.interface';
import { BrowseEntry } from '@experience/shop/shared-browse/interfaces/browse-entry.interface';
import { Address } from '@support/api/proxies/responses/api-2004.interface';
import { AddressFormComponentInput } from '@support/shared/widgets/interfaces/address-form.interface';

export class CardAddressModel {
  public address1: InputItemData;
  public address2: InputItemData;
  public city: InputItemData;
  public state: InputItemData;
  public zipCode: InputItemData;
  public urbanisation: InputItemData;
  public country: InputItemData;

  constructor(
    isInternationalPayment?: boolean,
    billingAddress?: BrowseEntry,
    data?: CardAddressModel
  ) {
    if (billingAddress && billingAddress.addresses) {
      this.address1 = this.setInitialValues(billingAddress.addresses.addressLine1, true);
      this.address2 = this.setInitialValues(billingAddress.addresses.addressLine2, true);
      this.city = this.setInitialValues(billingAddress.addresses.cityName, true);
      this.state = this.setInitialValues(billingAddress.addresses.stateCode, true);
      this.zipCode = this.setInitialValues(billingAddress.addresses.postalCode, true);
      if (isInternationalPayment) {
        this.country = this.setInitialValues(billingAddress.addresses.countryCode, true);
      }
    } else {
      this.initiDataWithAddress(isInternationalPayment, data);
    }
  }
  /**
   * Set adress fields
   * @param selectedAddress
   */
  public setAddressFields(selectedAddress: Address): void {
    this.address1 = this.setInitialValues(selectedAddress.addressLine1, true);
    this.address2 = this.setInitialValues(selectedAddress.addressLine2, true);
    this.city = this.setInitialValues(selectedAddress.cityName, true);
    this.state = this.setInitialValues(selectedAddress.stateCode, true);
    this.zipCode = this.setInitialValues(selectedAddress.postalCode, true);
  }
  /**
   * fetch adress fields
   * @returns AddressFormComponentInput
   */
  public getAddressFields(isInternationalPayment?: boolean): AddressFormComponentInput {
    const address: AddressFormComponentInput = {
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      state: this.state,
      zipCode: this.zipCode,
    };
    if (isInternationalPayment) {
      address.country = this.country;
    }
    return address;
  }

  /**
   * Initializes model data with address info
   * @param address Address Info
   * @returns void
   */
  /* tslint:disable:cyclomatic-complexity */
  private initiDataWithAddress(isInternationalPayment?: boolean, data?: CardAddressModel): void {
    this.address1 = this.setInitialValues(data && data.address1 ? data.address1.value : '', true);
    this.address2 = this.setInitialValues(data && data.address2 ? data.address2.value : '', false);
    this.city = this.setInitialValues(data && data.city ? data.city.value : '', true);
    this.state = this.setInitialValues(data && data.state ? data.state.value : '', true);
    this.zipCode = this.setInitialValues(data && data.zipCode ? data.zipCode.value : '', true);
    this.urbanisation = this.setInitialValues(
      data && data.urbanisation ? data.urbanisation.value : '',
      false
    );
    if (isInternationalPayment) {
      this.country = this.setInitialValues(data && data.country ? data.country.value : '', true);
    }
  }

  /**
   * Set initial values of the variables
   * @param value String value
   * @param required boolean value
   * @returns InputItemData
   */
  private setInitialValues(value: string, required: boolean): InputItemData {
    return {
      value: value || '',
      required: required,
    };
  }
}
